var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpinner({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M11.754 3.169c.266.872-.224 1.796-1.095 2.063a6.87 6.87 0 0 0-2.983 1.853c-.818.866-1.396 1.93-1.68 3.088s-.262 2.369.062 3.516.94 2.19 1.788 3.027a6.87 6.87 0 0 0 3.047 1.747c1.149.308 2.359.312 3.51.011s2.205-.896 3.058-1.728 1.475-1.87 1.807-3.015a1.65 1.65 0 0 1 2.043-1.126c.875.254 1.378 1.17 1.124 2.047a10.19 10.19 0 0 1-2.674 4.463c-1.262 1.23-2.821 2.111-4.525 2.557a10.15 10.15 0 0 1-5.196-.016c-1.701-.456-3.255-1.347-4.509-2.585a10.19 10.19 0 0 1-2.646-4.479c-.48-1.697-.511-3.491-.091-5.204a10.19 10.19 0 0 1 2.487-4.57c1.21-1.282 2.731-2.227 4.416-2.743a1.65 1.65 0 0 1 2.059 1.097z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinner);
export default __webpack_public_path__ + "static/media/spinner.29f75d5d6ba69acf993a516809dc58aa.svg";
export { ForwardRef as ReactComponent };